(function () {
  // v4: home-only + permanent dismiss (X / No thanks)
  var STORAGE_KEY = 'fe_welcome_dismissed_v4';
  var COOKIE_KEY = 'fe_welcome_dismissed_v4';
  var DELAY_DESKTOP_MS = 3800;
  var DELAY_MOBILE_MS = 2800;

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function isHomePage() {
    if (document.body && document.body.classList.contains('template-index')) return true;
    var path = (window.location.pathname || '/').replace(/\/+$/, '') || '/';
    // Root or locale root: /, /en, /de, /en-de, etc. (no extra segments)
    if (path === '/') return true;
    if (/^\/[a-z]{2}(-[a-z]{2})?$/i.test(path)) return true;
    return false;
  }

  function forceOpen() {
    try {
      return new URLSearchParams(window.location.search).get('fe_welcome') === '1';
    } catch (e) {
      return false;
    }
  }

  function readCookie(name) {
    var match = document.cookie.match(
      new RegExp('(?:^|;\\s*)' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)')
    );
    return match ? decodeURIComponent(match[1]) : '';
  }

  function writeCookie(name, value, days) {
    var expires = new Date();
    expires.setDate(expires.getDate() + (days || 365));
    var secure = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie =
      name +
      '=' +
      encodeURIComponent(value) +
      '; expires=' +
      expires.toUTCString() +
      '; path=/; SameSite=Lax' +
      secure;
  }

  function clearCookie(name) {
    document.cookie =
      name +
      '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax';
  }

  function wasDismissed() {
    try {
      if (window.localStorage.getItem(STORAGE_KEY) === '1') return true;
      // Honour older dismiss keys too
      if (window.localStorage.getItem('fe_welcome_dismissed_v3') === '1') return true;
    } catch (e) {}
    if (readCookie(COOKIE_KEY) === '1') return true;
    if (readCookie('fe_welcome_dismissed_v3') === '1') return true;
    var promo = qs('[data-cookie-name]');
    var themeName = promo ? promo.getAttribute('data-cookie-name') || '' : '';
    if (themeName && readCookie(themeName) === 'user_has_closed') return true;
    return false;
  }

  function markDismissed(section) {
    try {
      window.localStorage.setItem(STORAGE_KEY, '1');
      window.localStorage.setItem('fe_welcome_dismissed_v3', '1');
    } catch (e) {}
    writeCookie(COOKIE_KEY, '1', 365);
    writeCookie('fe_welcome_dismissed_v3', '1', 365);
    document.documentElement.classList.add('fe-welcome-dismissed');

    var promo =
      (section && qs('[data-cookie-name]', section)) || qs('[data-cookie-name]');
    var themeName = promo ? promo.getAttribute('data-cookie-name') : '';
    if (themeName) writeCookie(themeName, 'user_has_closed', 365);
  }

  function unlockScroll() {
    document.documentElement.classList.remove('fe-welcome-open');
    document.body.classList.remove('fe-welcome-open');
    document.documentElement.style.removeProperty('overflow');
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('position');
    document.body.style.removeProperty('top');
    document.body.style.removeProperty('width');
    document.body.style.removeProperty('padding-right');
    try {
      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
    } catch (e) {}
    document.documentElement.classList.remove('scroll-lock', 'no-scroll', 'is-locked');
    document.body.classList.remove('scroll-lock', 'no-scroll', 'is-locked');
  }

  function removePopup(section) {
    if (!section) return;
    try {
      section.remove();
    } catch (e) {
      if (section.parentNode) section.parentNode.removeChild(section);
    }
  }

  function openDialog(dialog) {
    if (!dialog) return;
    dialog.removeAttribute('inert');
    dialog.classList.add('is-visible');
    try {
      if (typeof dialog.showModal === 'function' && !dialog.open) {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
    } catch (e) {
      dialog.setAttribute('open', '');
    }
    document.documentElement.classList.add('fe-welcome-open');
  }

  function closeDialog(dialog, section) {
    if (!dialog) return;
    try {
      dialog.dispatchEvent(new CustomEvent('theme:popup:onclose', { bubbles: false }));
    } catch (e) {}
    try {
      if (typeof dialog.close === 'function' && dialog.open) dialog.close();
      else dialog.removeAttribute('open');
    } catch (e) {
      dialog.removeAttribute('open');
    }
    dialog.classList.remove('is-visible');
    dialog.setAttribute('inert', '');
    markDismissed(section);
    unlockScroll();
    removePopup(section);
    window.setTimeout(unlockScroll, 0);
    window.setTimeout(unlockScroll, 50);
    window.setTimeout(unlockScroll, 200);
  }

  function bindCopy(root) {
    var btn = qs('[data-fe-nl-copy]', root);
    var codeEl = qs('[data-fe-nl-code]', root);
    if (!btn || !codeEl || btn.getAttribute('data-bound') === 'true') return;
    btn.setAttribute('data-bound', 'true');
    btn.addEventListener('click', function () {
      var code = (codeEl.textContent || '').trim();
      if (!code) return;
      var done = function () {
        var prev = btn.textContent;
        btn.textContent = 'Copied';
        setTimeout(function () {
          btn.textContent = prev || 'Copy';
        }, 1400);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done).catch(function () {
          fallbackCopy(code, done);
        });
      } else {
        fallbackCopy(code, done);
      }
    });
  }

  function fallbackCopy(text, done) {
    var input = document.createElement('textarea');
    input.value = text;
    input.setAttribute('readonly', '');
    input.style.position = 'absolute';
    input.style.left = '-9999px';
    document.body.appendChild(input);
    input.select();
    try {
      document.execCommand('copy');
      done();
    } catch (e) {}
    document.body.removeChild(input);
  }

  function initPopup(section) {
    if (!section || section.getAttribute('data-fe-welcome-ready') === 'true') return;
    var dialog = qs('dialog.fe-welcome-dialog', section) || qs('[data-large-promo-inner]', section);
    if (!dialog) return;
    section.setAttribute('data-fe-welcome-ready', 'true');

    var promo = qs('[data-large-promo]', section);
    if (promo) {
      promo.removeAttribute('data-large-promo');
      promo.setAttribute('data-fe-welcome-promo', '');
    }

    qsa('[data-popup-close], .fe-welcome-close, .fe-welcome-dismiss', section).forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        closeDialog(dialog, section);
      });
    });

    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      closeDialog(dialog, section);
    });

    dialog.addEventListener('close', function () {
      unlockScroll();
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closeDialog(dialog, section);
    });

    qsa('[data-fe-nl-success]', section).forEach(bindCopy);

    if (forceOpen()) {
      try {
        window.localStorage.removeItem(STORAGE_KEY);
        window.localStorage.removeItem('fe_welcome_dismissed_v3');
      } catch (e) {}
      clearCookie(COOKIE_KEY);
      clearCookie('fe_welcome_dismissed_v3');
      document.documentElement.classList.remove('fe-welcome-dismissed');
      openDialog(dialog);
      return;
    }

    if (wasDismissed()) {
      removePopup(section);
      return;
    }

    // Never open outside the homepage
    if (!isHomePage()) {
      removePopup(section);
      return;
    }

    dialog.setAttribute('inert', '');
    dialog.classList.remove('is-visible');

    var delay = isMobile() ? DELAY_MOBILE_MS : DELAY_DESKTOP_MS;
    window.setTimeout(function () {
      if (wasDismissed() || !isHomePage()) {
        removePopup(section);
        return;
      }
      if (dialog.open) return;
      openDialog(dialog);
    }, delay);
  }

  function boot() {
    qsa('.fe-welcome-popup-section').forEach(initPopup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
